import css from './sass/style.scss';

require('./js/init.js');
require('./js/inview.js');
require('./js/lazy.js');
require('./js/nav.js');
require('./js/polyfills.js');
require('./js/scrollpos.js');
require('./js/smoothscroll.js');
